<template>
    <div class="wrapper">
        <div class="logo">
            <img src="../../assets/images/logo.png" alt="">
        </div>
    </div>
</template>
<style scoped lang="less">
    .wrapper{        
        position: fixed;
        width: 100%;
        height: 100%;
        left:0;
        top:0;
        right:0;
        bottom: 0;
        .logo{
            position: absolute;
            top:50%;
            left:50%;
            width:144px;
            height: 144px;
            transform: translate(-50%,-50%);
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
</style>
<script>
export default {
    mounted () {        
        window.location.href = "sampacash://"
        setTimeout(()=>{
            this.$router.replace({
                path:"/"
            })
        },5000)
    }
}
</script>